import React from "react";
import { InsightHighlightCard } from "./InsightHighlightCard";
import { InsightsPanelSkeleton } from "../shared/InsightsPanelSkeleton";

export interface MonthAtGlanceInsight {
  accentColor: "success" | "warning" | "brand" | "neutral";
  title: string;
  description: string;
}

export interface MonthAtGlanceInsightsPanelProps {
  insights: MonthAtGlanceInsight[];
  /** When true, renders InsightsPanelSkeleton instead of content */
  loading?: boolean;
  /** When set, shows an error state instead of blank/dummy content */
  error?: string | null;
}

export function MonthAtGlanceInsightsPanel({
  insights,
  loading = false,
  error = null,
}: MonthAtGlanceInsightsPanelProps) {
  if (loading) {
    return <InsightsPanelSkeleton />;
  }

  if (error) {
    return (
      <div className="flex min-h-0 w-full flex-col gap-3">
        <div className="w-full rounded-lg bg-error-50 px-4 py-3" role="alert">
          <span className="text-caption font-caption text-error-600">
            Error loading insights
          </span>
          <div className="mt-1">
            <span className="text-caption font-caption text-error-600">
              {error}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-3">
      {insights.map((insight, i) => (
        <div key={i} className="flex min-h-0 flex-1 basis-0 flex-col">
          <InsightHighlightCard
            accentColor={insight.accentColor}
            title={insight.title}
            description={insight.description}
            className="h-full min-h-0 flex-1"
          />
        </div>
      ))}
    </div>
  );
}
